import React, { useState, useEffect, useCallback, useMemo } from 'react';
import styled from 'styled-components';
import axios from '../axios';

import AddList from '../components/lists/addList';
import ChooseList from '../components/lists/chooseList';

//#region Styled Components
const StyledLists = styled.div`
  border: 1px solid var(--border-main);
  border-radius: 5px;
  position: fixed;
  padding: 1rem;
  top: 0;
  right: 0;
  margin: 1rem;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-end;
  z-index: 11;
  background-color: white;
  height: 7.5rem;
`;
//#endregion

const Lists = ({ selectedList, setSelectedList }) => {
  const [allLists, setAllLists] = useState([]);

  const addNewList = list => setAllLists(allLists => [...allLists, list]);

  const getAllLists = useCallback(async () => {
    try {
      const response = await axios.get('/lists.json');
      const lists = [];
      for (let key in response.data) {
        lists.push({
          ...response.data[key],
          id: key,
        });
      }
      setAllLists(lists);
    } catch (error) {
      throw error;
    }
  }, [setAllLists]);

  useEffect(() => {
    getAllLists();
  }, [getAllLists]);

  const sortedLists = useMemo(
    () => allLists.sort((a, b) => (a.name > b.name ? 1 : -1)),
    [allLists]
  );

  return (
    <StyledLists>
      <AddList addNewList={addNewList} />
      <ChooseList
        allLists={sortedLists}
        selectedList={selectedList}
        setSelectedList={setSelectedList}
      />
    </StyledLists>
  );
};

export default Lists;
